export enum InventoryRowActionTypes {
  RowClick = 'rowClick',
  InventoryEvent = 'inventoryEvent',
}
